import { atom } from "recoil";

const receivingCallState = atom({ key: "ReceivingCallState", default: false });

export default receivingCallState;
